import { render, staticRenderFns } from "./BaseCitesFade2.vue?vue&type=template&id=5077af66&scoped=true&"
import script from "./BaseCitesFade2.vue?vue&type=script&lang=js&"
export * from "./BaseCitesFade2.vue?vue&type=script&lang=js&"
import style0 from "./BaseCitesFade2.vue?vue&type=style&index=0&id=5077af66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_e0fc12eb4d0f55f4cb07c19882e21395/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5077af66",
  null
  
)

export default component.exports